import React, { Component, Fragment } from 'react'
import { Typography, Grid, Divider, Button} from '@material-ui/core'
import ColorPicker from './ColorPicker'
import {connect } from 'react-redux'
import {userOptionsColors} from '../../../../../store/Actions/memberActions/memberActions'
import LogoUpload from '../UserProfilePage/LogoUpload'



class CompanyStyle extends Component {

  constructor(props){
    super(props);
    this.state = {
      headerBgColor:  '#FFFFFF',
      headerColor:  '#666666',
      buttonBgColor: '#69b4a7',
      buttonColor: '#ffffff',
      menuLeftBgColor: '#ffffff',
      menuLeftColor:  '#69b4a7',
      companyId: ''
     
    }
  }
  handleChangeHeaderBgColor = (color) => {
    this.setState({ headerBgColor: color.hex})
    sessionStorage.setItem('headerBgColor', color.hex)
    this.props.handleColorChange()
  };
  handleChangeHeaderColor = (color) => {
    this.setState({ headerColor: color.hex})
    sessionStorage.setItem('headerColor', color.hex)
    this.props.handleColorChange()
  };
  handleChangeButtonBgColor = (color) => {
    this.setState({ buttonBgColor: color.hex})
    sessionStorage.setItem('buttonBgColor', color.hex)
    this.props.handleColorChange()
  };
  handleChangeButtonColor = (color) => {
    this.setState({ buttonColor: color.hex})
    sessionStorage.setItem('buttonColor', color.hex)
    this.props.handleColorChange()
  };
  handleChangeMenuLeftBg= (color) => {
    this.setState({ menuLeftBgColor: color.hex})
    sessionStorage.setItem('menuLeftBgColor', color.hex)
    this.props.handleColorChange()
  };
  handleChangeMenuLeftColor = (color) => {
    this.setState({ menuLeftColor: color.hex})
    sessionStorage.setItem('menuLeftColor', color.hex)
    this.props.handleColorChange()
  };
  handleUserOptionsColors = (e) => {
    this.props.userOptionsColors(this.state)
  }
  handleLogoChange = (e) => {
    //console.log('CompanyStyle - handleLogoChange')
    this.props.handleLogoChange()
  }
  setColors(){
      

        this.setState({
        ...this.state,
        companyId: sessionStorage.getItem('companyId'),
        headerBgColor: sessionStorage.getItem('headerBgColor'),
        headerColor: sessionStorage.getItem('headerColor'),
        buttonBgColor: sessionStorage.getItem('buttonBgColor'),
        buttonColor: sessionStorage.getItem('buttonColor'),
        menuLeftBgColor: sessionStorage.getItem('menuLeftBgColor'),
        menuLeftColor: sessionStorage.getItem('menuLeftColor'),
      })
    
  }
  initialize = async () => {
    await this.setColors();
  }
  componentWillMount(){
    
  }
  componentDidMount() {  
    this.initialize();
  }


  render() {
    let buttonBg = this.state.buttonBgColor
    let buttonCol = this.state.buttonColor
    //console.log(this.props)
    return (
      <Fragment>
        <Grid container >
            <Grid item xs={12}>
            <Typography component="h1" variant="h5">
            Personalise Style
              </Typography>
              <Typography component="p" style={{marginTop: '12px', marginBottom: '24px'}}>
                There is alittle line below this heading that explains what information you can put in this section.
            </Typography>
            <Divider style={{marginBottom: '24px'}}/>
            </Grid>
            
            <Grid item xs={12} sm={4}>
             
                <Typography variant="title" gutterBottom> Logo </Typography>
                <LogoUpload handleLogoChange={this.handleLogoChange} companyId={this.state.companyId} style={{position: 'relative', zIndex: '2'}}/>
            </Grid>
            <Grid item xs={12} sm={8}>
                <Grid container>
                  <Grid item xs={12} md={6} sm={12} style={{padding: '4px'}}>
                    <Grid item xs={12} sm={12}>
                      <Typography variant="title" gutterBottom> Header </Typography>
                      <Divider/>
                    </Grid>
                    <Grid container>
                      <Grid item xs={6} sm={6} style={{position: 'relative'}} >
                          <Typography variant="overline" gutterBottom>
                          Background
                          </Typography>
                          <ColorPicker handleChange={this.handleChangeHeaderBgColor} backgroundColor={this.state.headerBgColor} />
                          <Typography variant="overline" gutterBottom>{this.state.headerBgColor}</Typography>
                      </Grid>
                      <Grid item xs={6} sm={6}  style={{position: 'relative'}}>
                          <Typography variant="overline" gutterBottom>
                            Color
                          </Typography>
                        
                            <ColorPicker handleChange={this.handleChangeHeaderColor} backgroundColor={this.state.headerColor} /><Typography variant="overline" gutterBottom>
                            {this.state.headerColor}
                          </Typography>
                      </Grid>
                    </Grid>

                  </Grid>
                  <Grid item xs={12} md={6} sm={12} style={{padding: '4px'}}>
                    <Grid item xs={12} sm={12}>
                      <Typography variant="title" gutterBottom> Buttons </Typography>
                      <Divider/>
                    </Grid>
                    <Grid container>
                      <Grid item xs={6}  sm={6} style={{position: 'relative'}} >
                          <Typography variant="overline" gutterBottom>
                          Background
                          </Typography>
                          <ColorPicker handleChange={this.handleChangeButtonBgColor} backgroundColor={this.state.buttonBgColor} />
                          <Typography variant="overline" gutterBottom>{this.state.buttonBgColor}</Typography>
                      </Grid>
                      <Grid item xs={6}  sm={6} style={{position:'relative'}}>
                          <Typography variant="overline" gutterBottom>
                            Color
                          </Typography>
                        
                            <ColorPicker handleChange={this.handleChangeButtonColor} backgroundColor={this.state.buttonColor} /><Typography variant="overline" gutterBottom>
                            {this.state.buttonColor}
                          </Typography>
                      </Grid>
                    </Grid>
                    
                  </Grid>
                  <Grid item xs={12} md={6} sm={12} style={{padding: '4px'}}>
                    <Grid item xs={12} sm={12}>
                      <Typography variant="title" gutterBottom> Menu left </Typography>
                      <Divider/>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={6} style={{position: 'relative'}} >
                            <Typography variant="overline" gutterBottom>
                            Background
                            </Typography>
                            <ColorPicker handleChange={this.handleChangeMenuLeftBg} backgroundColor={this.state.menuLeftBgColor} />
                            <Typography variant="overline" gutterBottom>{this.state.menuLeftBgColor}</Typography>
                        </Grid>
                        <Grid item xs={6}  sm={6} style={{position:'relative'}}>
                            <Typography variant="overline" gutterBottom>
                              Color
                            </Typography>
                          
                              <ColorPicker handleChange={this.handleChangeMenuLeftColor} backgroundColor={this.state.menuLeftColor} /><Typography variant="overline" gutterBottom>
                              {this.state.menuLeftColor}
                            </Typography>
                        </Grid>

                    </Grid>
                    
                  </Grid>

                </Grid>
                <Divider style={{marginTop: '24px'}}/>
                <Button onClick={this.handleUserOptionsColors} variant="contained"   type="submit"  style={{background: buttonBg, color: buttonCol, marginTop: '24px', padding: '7px 47px'}}>
                  Save
                </Button>
            </Grid>
            
        </Grid>
      </Fragment>
    )
  }
}

export default  connect(null,{userOptionsColors})(CompanyStyle)
